module.exports = __webpack_public_path__ + "img/productPage4.e0aa6f0e.png";